<template>
  <v-tooltip top>
    <template #activator="{on}">
      <span v-on="on"
            class="nx-list-item-flag"
            :style="`border-color: transparent transparent ${calculatedColor} transparent`"></span>
    </template>
    <strong v-text="translatedTooltip"></strong>
  </v-tooltip>
</template>

<script>
const COLOR_MAP = {
  green: '#4ed19c',
  orange: '#ffa01c',
};

export default {
  props: {
    color: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
    },
  },
  computed: {
    translatedTooltip() {
      return this.$te(`message.${this.tooltip}`) ? this.$t(`message.${this.tooltip}`) : this.tooltip;
    },
    calculatedColor() {
      return COLOR_MAP[this.color] || this.color;
    },
  },
};
</script>

<style lang="stylus">
  .nx-list-item-flag {
    content: "";
    position: absolute;
    bottom: 0;
    right: 0;
    border-style: solid;
    border-width: 0 0 16px 16px;
  }
</style>
